<template>
  <div>
    <v-dialog v-model="dialog" persistent scrollable="" max-width="800px">
      <v-card>
        <v-card-title>
          <div class="flex-grow-1">
            <span class="headline"
              ><v-icon>mdi-account-check-outline</v-icon> Validar
              solicitud</span
            >
          </div>

          <div class="flex-grow-1 text-right">
            <v-btn icon @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row v-if="loading">
            <v-flex v-for="i in [1, 2, 3, 4]" :key="'sl_docto_' + i" xs12>
              <v-skeleton-loader
                type="heading"
                class="py-4 px-3"
                max-width=""
              />
            </v-flex>
          </v-row>
          <v-expansion-panels v-else focusable hover class="mt-2">
            <v-expansion-panel
              v-for="i in intServicioRequisitos"
              :key="'sl_isrv_' + i.idServicioRequisitoPk"
            >
              <v-expansion-panel-header>
                <v-row no-gutters>
                  <!-- <v-col cols="6" v-if="i.idServicioFk != 219">{{
                    i.idTipoDocDigFk == null
                      ? "Datos complementarios"
                      : i.idTipoDocDigFkNavigation.descripcion
                  }}</v-col> -->
                  <v-col cols="6">{{
                    i.idTipoDocDigFk == null
                      ? "Datos del registro"
                      : i.idTipoDocDigFkNavigation.descripcion
                  }}</v-col>
                  <v-col cols="6" class="text--secondary">
                    Estatus:
                    <b>{{
                      i.externoServicioRequisito === null
                        ? "Sin completar"
                        : i.externoServicioRequisito.observacionRechazado !=
                          null
                        ? "Con observaciones"
                        : i.externoServicioRequisito.fechaHValidacion == null
                        ? "Por validar"
                        : "Validado"
                    }}</b>
                  </v-col>
                </v-row>

                <!--<template v-slot:actions>
                 <v-icon
                    v-if="requisitoValidado(i.idServicioRequisitoPk)"
                    color="teal"
                    >mdi-check</v-icon
                  >

                  <v-icon v-else color="error">mdi-alert-circle</v-icon> 
                </template>-->
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-3">
                <v-alert
                  v-if="i.externoServicioRequisito === null"
                  type="warning"
                >
                  No se ha cargado información.
                </v-alert>
                <validacion-documento
                  v-else-if="i.idTipoDocDigFk !== null"
                  :id-ext-serv-req-pk="
                    i.externoServicioRequisito.idExtServReqPk
                  "
                  :actualizar-requisitos="getRequisitosServicioAdministrador_"
                  :refresh-table="refreshTable"
                />
                <validacion-formulario
                  v-else
                  :id-ext-serv-req-pk="
                    i.externoServicioRequisito.idExtServReqPk
                  "
                  :actualizar-requisitos="getRequisitosServicioAdministrador_"
                  :refresh-table="refreshTable"
                />
                <!-- <div v-if="i.externoServicioRequisito !== null">
                  <v-alert
                    v-if="
                      i.externoServicioRequisito.observacionRechazado !== null
                    "
                    type="warning"
                    class="mt-5 mb-0"
                  >
                    {{ i.externoServicioRequisito.observacionRechazado }}
                  </v-alert>
                </div>
                <formulario-servicio
                  v-if="i.idTipoDocDigFk == null"
                  :id-servicio="idServicio"
                  :validar-requisito="validarRequisito"
                  :id-requisito="i.idServicioRequisitoPk"
                  :set-form-values="setFormValues"
                  :id-estatus="idEstatus"
                ></formulario-servicio>
                <formulario-documento
                  v-else
                  :tipoDocumento="i.idTipoDocDigFkNavigation"
                  :validar-requisito="validarRequisito"
                  :id-requisito="i.idServicioRequisitoPk"
                  :id-estatus="idEstatus"
                ></formulario-documento> -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { getRequisitosServicioAdministrador } from "@/api";
export default {
  name: "FichaSolicitudValidacion",
  components: {
    ValidacionDocumento: () =>
      import("../../components/molecules/ValidacionDocumento"),
    ValidacionFormulario: () =>
      import("../../components/molecules/ValidacionFormulario"),
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    closeDialog: {
      type: Function,
      required: true,
    },
    refreshTable: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      intServicioRequisitos: [],
    };
  },
  watch: {
    dialog: {
      handler(newValue, oldValue) {
        if (newValue) {
          if (this.item.idServicioFk !== undefined) {
            this.getRequisitosServicioAdministrador_();
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    //this.getRequisitosServicioAdministrador_();
  },
  methods: {
    async getRequisitosServicioAdministrador_() {
      var self = this;
      self.loading = true;
      self.intServicioRequisitos = [];
      self.snackbarError = false;
      self.textoError = "";

      try {
        let response = await getRequisitosServicioAdministrador(
          self.item.idServicioFk,
          self.item.idUsuarioExterno
        );

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              self.intServicioRequisitos = response.data.data;
              self.loading = false;
            } else {
              self.loading = false;
              self.intServicioRequisitos = [];
            }
          } else {
            self.loading = false;
            self.intServicioRequisitos = [];

            self.snackbarError = true;
            self.textoError = response.data.message;
          }
        } else {
          self.loading = false;
          self.intServicioRequisitos = [];

          self.snackbarError = true;
          self.textoError = "Error de red";
        }
      } catch (e) {
        self.loading = false;
        self.intServicioRequisitos = [];

        self.snackbarError = true;
        self.textoError = e;
      }
    },
  },
};
</script>

<style></style>
